import Vue from "vue";
import SearchBar from "@/components/ClinicsResult/SearchBar/SearchBar.vue";

import NotFoundImage from "@/assets/images/no_result_image.png";

import { Component } from "vue-property-decorator";

import router from "@/router";

const NoResultAreaProps = Vue.extend({
  props: {},
});

@Component({
  name: "NotFoundPage",
  components: {
    "search-bar": SearchBar,
  },
})
export default class NoResultArea extends NoResultAreaProps {
  cx_image = NotFoundImage;

  goToHome(): void {
    router.push({
      name: "Home",
    });
  }
}
